export function getKeyByValue(object, val) {
    const strVal = JSON.stringify(val)
    const keys = Object.keys(object)
    let key = ''

    keys.map(i => {
        if (JSON.stringify(object[i]) == strVal) key = i
    })

    return key
}
